export const CLUSTER = "CLUSTER";
export const SEGMENTS = "SEGMENTS";
export const SELECTED_COUNTRIES = "SELECTED_COUNTRIES";
